// extracted by mini-css-extract-plugin
export default {"UIButton":"UIButton_UIButton__+o1hZ"};